import { z } from 'zod';
import { recapMetricSchema } from './monday-recap.js';
// Friday brief (s213). Spec §6 — "Friday 4pm · The Brief":
//   - honest performance summary
//   - "what I got wrong this week" (baked in, not optional)
//   - what's changing next week
//   - one question for the founder if relevant
//
// Companion to Monday recap. Same brand-tz scheduling pattern,
// same metric tile shape (reused from monday-recap), inverted
// stance: Monday opens the week with intent; Friday closes it
// with honest assessment. The "what i got wrong" block is the
// agency-feel moment that differentiates Mag from a dashboard.
export const fridayBriefPayloadSchema = z.object({
    kind: z.literal('friday_brief'),
    weekEndDate: z.string(),
    tz: z.string().min(1).max(60),
    metrics: z.array(recapMetricSchema).max(5),
    /** One short paragraph — honest performance read. Not a victory
     *  lap. Mag voice. */
    performance: z.string().min(1).max(500),
    /** "What I got wrong this week" — 0..5 acknowledgments. Empty is
     *  allowed (clean weeks happen), but the agent's prompt is told
     *  not to skip lightly. */
    gotWrong: z.array(z.string().min(1).max(280)).max(5),
    /** What's changing next week — 1..5 bullets. */
    changingNextWeek: z.array(z.string().min(1).max(280)).min(1).max(5),
    /** Optional single question for the founder. Null when there's
     *  nothing worth asking. */
    questionForYou: z.string().min(1).max(280).nullable(),
});
export const fridayBriefAgentOutputSchema = z.object({
    performance: z.string().min(1).max(500),
    gotWrong: z.array(z.string().min(1).max(280)).max(5),
    changingNextWeek: z.array(z.string().min(1).max(280)).min(1).max(5),
    questionForYou: z.string().min(1).max(280).nullable(),
});
//# sourceMappingURL=friday-brief.js.map